import React from 'react';
import { CheckBox as BaseCheckBox } from '@kvdbil/components';
import { CheckBoxProps as BaseCheckBoxProps } from '@kvdbil/components/types/components/CheckBox';
import {
  Control,
  Controller,
  FieldValues,
  Path,
  PathValue
} from 'react-hook-form';
import { ControllerRules } from '~/App/shared/interfaces/ControllerRules';

export type CheckBoxProps<FormState extends FieldValues> = Omit<
  BaseCheckBoxProps,
  'checked'
> & {
  control: Control<FormState>;
  name: Path<FormState>;
  rules?: ControllerRules;
  defaultValue?: PathValue<FormState, Path<FormState>>;
};

const CheckBoxWithRef = React.forwardRef((props: BaseCheckBoxProps, ref) => (
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore next-line
  <BaseCheckBox {...props} forwardRef={ref} />
));

const CheckBoxWithControl = <FormState extends FieldValues>(
  props: CheckBoxProps<FormState>
) => {
  return (
    <Controller<FormState>
      {...props}
      render={({ field, fieldState }) => (
        <CheckBoxWithRef
          {...props}
          {...field}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            props.onChange?.(e);
            field.onChange(e.target.checked);
          }}
          value={field.value}
          checked={Boolean(field.value)}
          hasError={Boolean(fieldState.error)}
        />
      )}
    />
  );
};

export default CheckBoxWithControl;
